import React from 'react';
import './CreditSection.css';

const CreditSection = () => {
  return (
    <section className="credit-section" id="programs">
      <div className="container credit-section-container">
        <div className="credit-content">
          <div className="credit-left">
            <div className="credit-tag">
              <svg className="credit-tag-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
              </svg>
              <span>FINANCIAL SOLUTIONS</span>
            </div>
            <h2 className="credit-title">
              Flexible Credit with <span className="credit-title-accent">CredBuy</span>
            </h2>
            <p className="credit-description">
              Apply for credit facilities designed to support your interior purchases and business growth. Simple application, transparent approval, and easy tracking.
            </p>
            <div className="credit-stats">
              <div className="credit-stat-box">
                <div className="credit-stat-value">0%</div>
                <div className="credit-stat-label">Processing Fees</div>
              </div>
              <div className="credit-stat-box">
                <div className="credit-stat-value">24h</div>
                <div className="credit-stat-label">Approval Time</div>
              </div>
            </div>
            <button type="button" className="credit-apply-btn">Apply for Credit</button>
          </div>
          <div className="credit-right">
            <h3 className="credit-right-title">Learn. Grow. Stay Ahead.</h3>
            <p className="credit-right-description">
              Upgrade your knowledge with expert-led courses and workshops focused on interior design, materials, and best practices.
            </p>
            <div className="credit-programs">
              <div className="credit-program-card">
                <div className="credit-program-icon credit-program-icon--book">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
                    <path d="M8 7h8" />
                    <path d="M8 11h8" />
                  </svg>
                </div>
                <div className="credit-program-text">
                  <h4 className="credit-program-title">Design Masterclass</h4>
                  <p className="credit-program-meta">24 Modules • Expert Led</p>
                </div>
              </div>
              <div className="credit-program-card">
                <div className="credit-program-icon credit-program-icon--chart">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 3v18h18" />
                    <path d="M18 17V9" />
                    <path d="M13 17V5" />
                    <path d="M8 17v-3" />
                  </svg>
                </div>
                <div className="credit-program-text">
                  <h4 className="credit-program-title">Business of Interior Design</h4>
                  <p className="credit-program-meta">12 Modules • Strategy</p>
                </div>
              </div>
            </div>
            <a href="#programs" className="credit-explore-link" rel="noopener noreferrer">
              Explore Programs
              <svg className="credit-explore-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CreditSection;
